'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = require('./prefix');

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = require('./supported-property');

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = require('./supported-value');

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  prefix: _prefix2.default,
  supportedProperty: _supportedProperty2.default,
  supportedValue: _supportedValue2.default
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2.default;
exports.supportedProperty = _supportedProperty2.default;
exports.supportedValue = _supportedValue2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-vendor/lib/index.js
 ** module id = 171
 ** module chunks = 0
 **/